import { getRestakeApy } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import { useIdle } from "react-use";

export function useRestakeApy() {
  const isIdle = useIdle(150e3);

  const { data: apyData, ...query } = useQuery({
    queryKey: ["restake-apy"],
    queryFn: async () => {
      return (await getRestakeApy()).data;
    },
    enabled: !isIdle,
    staleTime: 30 * 1000, // 30 seconds - APY doesn't change frequently
    refetchInterval: 30 * 1000, // Refetch every 30 seconds
    placeholderData: (previousData) => previousData, // Keep old data while refetching
    refetchIntervalInBackground: false,
  });

  // Calculate APY values - only when data exists
  const eigenAPY =
    apyData?.eigenAPY && apyData.eigenAPY > 0 ? apyData.eigenAPY : 0;

  const calculatedTotalAPY = apyData
    ? Number((apyData.kelpAPY + eigenAPY).toFixed(1))
    : 0;

  return {
    ...query,
    data: apyData,
    is7DayApy: apyData?.is7DaysKelpAPY,
    kelpAPY: apyData?.kelpAPY || 0,
    roundedTotalAPY: apyData ? `${apyData.roundedTotalAPY}%` : "-",
    eigenAPY,
    totalAPY: apyData?.totalAPY || 0,
    calculatedTotalAPY: apyData ? apyData.roundedTotalAPY : 0,
    formattedAPY: apyData ? `${calculatedTotalAPY}%` : "-",
    formattedTotalAPY: apyData ? `${apyData.totalAPY.toFixed(1)}%` : "-",
    rawData: apyData,
  };
}
